/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media screen and (min-width:1280px){.order-label{width:40%;height:80%}}.order-label .mat-dialog-container{padding:0}"];
export { styles as styles };
